import { render, staticRenderFns } from "./public-holiday.vue?vue&type=template&id=320a5f14&scoped=true"
import script from "./public-holiday.vue?vue&type=script&lang=js"
export * from "./public-holiday.vue?vue&type=script&lang=js"
import style0 from "./public-holiday.vue?vue&type=style&index=0&id=320a5f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a5f14",
  null
  
)

export default component.exports